module.exports = __webpack_public_path__ + "assets-cabinet/img/hidden.bcdb402b.svg";